import { DefaultPrimaryButton, DefaultSecondaryButton, Squircle } from '@frontend/components/common';
import { ICONS } from '@frontend/icons';
import { TELLOPORT_RADIUS } from '@frontend/repository';
import React from 'react';
import { FormattedMessage } from 'react-intl';

interface ActionModalProps {
    title: React.ReactNode;
    children: React.ReactNode;
    cancel: {
        onCancel: () => void;
        label?: React.ReactNode;
        hide?: boolean;
    };
    confirm: {
        onConfirm: () => void;
        label?: React.ReactNode;
        disabled?: boolean;
        isLoading?: boolean;
        hide?: boolean;
    };
    additionalButtons?: { onClick: () => void; label: React.ReactNode; disabled?: boolean; isLoading?: boolean }[];
}

export const ActionModal = (props: ActionModalProps) => {
    return (
        <div style={{ filter: 'drop-shadow(0 0 0 1px var(--color-border-default))' }}>
            <Squircle
                cornerRadius={TELLOPORT_RADIUS.lg}
                className='bg-background-surface inline-flex w-full flex-col items-center justify-center gap-6 p-6'>
                <div className='inline-flex flex-col items-start justify-start gap-2 self-stretch'>
                    <div className='inline-flex h-6 items-center justify-between self-stretch'>
                        <div className='text-foreground-default text-lg font-semibold'>{props.title}</div>
                        <ICONS.BUTTON.CLOSE
                            className='hover:cursor-pointer'
                            onClick={props.cancel.onCancel}
                        />
                    </div>
                    {props.children}
                </div>
                <div className='inline-flex items-start justify-end gap-3 self-stretch'>
                    {!props.cancel.hide && (
                        <DefaultSecondaryButton
                            onClick={props.cancel.onCancel}
                            text={props.cancel.label ?? DefaultCancel}
                        />
                    )}
                    {!props.confirm.hide && (
                        <DefaultPrimaryButton
                            onClick={props.confirm.onConfirm}
                            text={props.confirm.label ?? DefaultConfirm}
                            disabled={props.confirm.disabled}
                            isLoading={props.confirm.isLoading}
                        />
                    )}

                    {props.additionalButtons &&
                        props.additionalButtons.map((button, index) => {
                            return (
                                <DefaultPrimaryButton
                                    key={index}
                                    onClick={button.onClick}
                                    text={button.label}
                                    disabled={button.disabled}
                                    isLoading={button.isLoading}
                                />
                            );
                        })}
                </div>
            </Squircle>
        </div>
    );
};

const DefaultConfirm = (
    <FormattedMessage
        id='action-modal.confirm'
        defaultMessage='Yes, cancel'
    />
);
const DefaultCancel = (
    <FormattedMessage
        id='action-modal.dont-cancel'
        defaultMessage="No, don't cancel"
    />
);
